// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as SentryErrorUtils from "./SentryErrorUtils.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";
import * as Utils$PorterinFusionkitSentryReact from "../../../node_modules/@porterin/fusionkit-sentry-react/src/Utils.bs.js";

function captureException(contexts, tags, error) {
  Curry._3(Lib$PorterinFusionkitSentry.React.captureErrorWithContextAndTag, SentryErrorUtils.toReportableError(error), contexts, tags);
  
}

function captureMessage(contexts, tags, message) {
  Curry._3(Lib$PorterinFusionkitSentry.React.captureMessageWithContextAndTag, message, contexts, tags);
  
}

var setTag = Lib$PorterinFusionkitSentry.React.setTag;

var setUser = Lib$PorterinFusionkitSentry.React.setUser;

var init = Lib$PorterinFusionkitSentry.React.initSentry;

var initOptions = Lib$PorterinFusionkitSentry.React.init_options;

var makeError = SentryErrorUtils.makeReportableError;

var setContext = Utils$PorterinFusionkitSentryReact.setContext;

export {
  captureException ,
  makeError ,
  captureMessage ,
  setTag ,
  setUser ,
  setContext ,
  init ,
  initOptions ,
  
}
/* Lib-PorterinFusionkitSentry Not a pure module */
